import {Injectable} from '@angular/core';

import {StorageService} from './abstract-storage.service';

@Injectable()
export class MemoryStorageService extends StorageService {
    constructor() {
        super({});
    }
}